import type { JSX } from 'react'
import Badge from '../common/badge/Badge'
import { BadgeColor } from '../common/badge/badgeTypes'
import {
    HelixSearchLogStatusV2,
    HelixSearchSessionStatusV2,
} from '../../api/helixSearchV2/models/StartHelixSearchV2'

const HELIX_SESSION_STATUS_COLORS: Record<
    HelixSearchSessionStatusV2,
    BadgeColor
> = {
    IN_PROGRESS: BadgeColor.Progress,
    COMPLETE: BadgeColor.Success,
    FAILED: BadgeColor.Error,
    CANCELLING: BadgeColor.Warning,
    CANCELED: BadgeColor.Neutral2,
    EXPIRED: BadgeColor.Neutral,
}

const HELIX_LOG_STATUS_COLORS: Record<HelixSearchLogStatusV2, BadgeColor> = {
    DISPATCH_PENDING: BadgeColor.Neutral,
    QUEUED: BadgeColor.InfoBlue,
    STARTED: BadgeColor.BrandBlue,
    SPLITTING_SEED_PERSONS: BadgeColor.Progress,
    SEARCHING_CANDIDATES: BadgeColor.Progress,
    SPLITTING_CANDIDATES: BadgeColor.Progress,
    COMBINING_RESULTS: BadgeColor.Progress,
    GETTING_CONTXT_SCORE: BadgeColor.Cyan,
    COMPLETE: BadgeColor.Success2,
    FAILED: BadgeColor.Error,
    CANCELLING: BadgeColor.WarningAmber,
    CANCELED: BadgeColor.Neutral2,
    EXPIRED: BadgeColor.Neutral,
}

type BadgeBaseProps = {
    className?: string
    title?: string
}

type HelixSearchSessionStatusBadgeProps = BadgeBaseProps & {
    status: HelixSearchSessionStatusV2
}

export function HelixSearchSessionStatusBadge({
    status,
    className,
    title,
}: HelixSearchSessionStatusBadgeProps): JSX.Element {
    return (
        <Badge
            color={HELIX_SESSION_STATUS_COLORS[status]}
            className={className}
            title={title}
        >
            {status}
        </Badge>
    )
}

type HelixSearchLogStatusBadgeProps = BadgeBaseProps & {
    status: HelixSearchLogStatusV2
}

export function HelixSearchLogStatusBadge({
    status,
    className,
    title,
}: HelixSearchLogStatusBadgeProps): JSX.Element {
    return (
        <Badge
            color={HELIX_LOG_STATUS_COLORS[status]}
            className={className}
            title={title}
        >
            {status}
        </Badge>
    )
}
